import React, { useEffect, useState } from 'react';
import '../index.css';
import TextField from 'material-ui/TextField';

function EditGradeTile (props) {

    const [state, setState] = useState({isGrading: false});

    useEffect(() => {
        setState({
            ...state,
            feedback: props.thisEvaluation.feedback,
            grade: props.thisEvaluation.teacherGrade !== undefined ? props.thisEvaluation.teacherGrade.toString() : "3",
            graded: props.thisEvaluation.teacherGrade !== undefined,
        });
    }, []);

    const handleChange = (e) => {
        setState({
            ...state,
            feedback: e.target.value
        });
    }

    const handleGradingClick = () => {
        setState({
            ...state,
            isGrading: !state.isGrading
        });
    }

    const handleSubmit = () => {
        setState({...state, isGrading: false, graded: true});
        props.handleGiveFeedback(props.thisEvaluation, props.thisSprint, state.feedback, state.grade);
    }

    const handleRadioChange = (e) => {
        setState({
            ...state,
            grade: e.target.innerText.trim()
        });
    }
    const {thisEvaluation: {nameOfReviewingStudent='',nameOfReviewedStudent=''} = {}} = props
    const splittedNameReviewing = nameOfReviewingStudent.split(",");
    const splittedNameReviewed = props.status !== "Unsubmitted"
        ? nameOfReviewedStudent.split(",")
        : null;
    const status = state.graded ? `Grade: ${state.grade}` : 'Ungraded';

    return (
        <div className="gradeTileContainer">
            <div className="gradeTile">
                {props.status !== "Unsubmitted" &&
                    <div className="questionsAnswers">
                        {props.thisEvaluation.questionAnswerPairs && props.thisEvaluation.questionAnswerPairs
                            .filter(questionAnswerPair => questionAnswerPair.type === "Text")
                            .map((questionAnswerPair, index) => {
                                return (
                                    <div className="questionsAnswer" key={index + "questionAnswerPair"}>
                                        <h5 className="question">Question {index + 1}: {questionAnswerPair.question}</h5>
                                        <h5 className="answer">{questionAnswerPair.answer}</h5>
                                    </div>
                                );
                            })
                        }
                    </div>
                }
                {state.isGrading ?
                    <div className="bottomPart">
                        <h2>Feedback</h2>
                        <h3>Grade:
                            <div
                                id={"grade"}
                                value="0"
                                style={state.grade === '0' ? {backgroundColor: "rgb(190, 190, 190)", color: "white", marginLeft: "30px"} : {marginLeft: "30px"}}
                                onClick={handleRadioChange}
                                className="radio"
                            >
                                <h5 id={"grade"} style={state.grade === '0' ? {color: "white"} : {}}>0</h5>
                            </div>
                            <div
                                id={"grade"}
                                value="1"
                                style={state.grade === '1' ? {backgroundColor: "rgb(190, 190, 190)", color: "white"} : {}}
                                onClick={handleRadioChange}
                                className="radio"
                            >
                                <h5 id={"grade"} style={state.grade === '1' ? {color: "white"} : {}}>1</h5>
                            </div>
                            <div
                                id={"grade"}
                                value="2"
                                style={state.grade === '2' ? {backgroundColor: "rgb(190, 190, 190)", color: "white"} : {}}
                                onClick={handleRadioChange}
                                className="radio"
                            >
                                <h5 id={"grade"} style={state.grade === '2' ? {color: "white"} : {}}>2</h5>
                            </div>
                            <div
                                id={"grade"}
                                value="3"
                                style={state.grade === '3' ? {backgroundColor: "rgb(190, 190, 190)", color: "white"} : {}}
                                onClick={handleRadioChange}
                                className="radio"
                            >
                                <h5 id={"grade"} style={state.grade === '3' ? {color: "white"} : {}}>3</h5>
                            </div>
                        </h3>
                        <TextField
                            hintText="Insert Feedback"
                            name="feedback"
                            onChange={handleChange}
                            value={state.feedback}
                            multiLine={true}
                            rows={1}
                            fullWidth={true}
                        />
                        <div className="buttons">
                            <button className="good" onClick={handleSubmit}>Submit</button>
                            <button className="improve" onClick={handleGradingClick}>Close</button>
                        </div>
                    </div>
                    :
                    <div className="bottomPart">
                        <h4>{props.thisAssignment.name}</h4>
                        <h2>{`${splittedNameReviewing[1]} ${splittedNameReviewing[0][0]}.`}</h2>
                        <h4>
                            {props.status !== "Unsubmitted"
                                ? `Reviewing ${splittedNameReviewed[1]} ${splittedNameReviewed[0][0]}.`
                                : 'Reviewing Unknown'
                            }
                        </h4>
                        <h4 className="status">{status}</h4>
                        {props.status !== "Unsubmitted" && 
                            <div className="buttons">
                                <button className="good" onClick={handleGradingClick}>Grade</button>
                            </div>
                        }
                    </div>
                }
            </div>
        </div>
    );
}

export default EditGradeTile;
